<template>
	<v-app>
		<v-snackbar
		v-model="alert.show"
		timeout="2000"
		right
		top
		:color="alertColor"
		>
		{{ alert.message }}
		<template v-slot:action="{ attrs }">
			<v-btn color="white" text v-bind="attrs" @click="hideAlert">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</template>
	</v-snackbar>
	<router-view></router-view>
</v-app>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
	computed : {
		...mapState(["alert"]),

		alertColor() {
			switch (this.alert.type) {
				case "success":
				return "green";

				case "warning":
				return "yellow";

				default:
				return "red";
			}
		},
	},
	methods: {
		...mapMutations(["hideAlert"]),
	}
}
</script>